import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard } from "@/components/pages/Portal/Dashboard/Dashboard";
import { WIPRepairOrders } from "@/components/pages/Portal/WIPRepairOrders/WIPRepairOrders";
import { Invoices } from "@/components/pages/Portal/Invoices/Invoices";
import { Requests } from "@/components/pages/Portal/Requests/Requests";
import { Reports } from "@/components/pages/Portal/Reports/Reports";
import { Archived } from "@/components/pages/Portal/Archived/Archived";
import { PortalTemplate } from "../PortalTemplate/PortalTemplate";
import { useCustomers } from "@/hooks/Customer";
import { NoCustomers } from "@/components/pages/NoCustomers/NoCustomers";
export interface IPortalRoutessProps {}

export function PortalRoutes(props: IPortalRoutessProps) {
	const customers = useCustomers();
	const hasCustomers = !!customers.data?.length;
	return (
		<PortalTemplate showCustomerPicker={hasCustomers} showSideNavigation>
			<>
				{!customers.isLoading && (
					<Routes>
						{/* <Route path="/dashboard" element={<Dashboard></Dashboard>}></Route> */}
						{hasCustomers ? (
							<>
								<Route path="/*" element={<Navigate to={"wip"} />}></Route>
								<Route path="/wip" element={<WIPRepairOrders />}></Route>
								<Route path="/ros" element={<Requests />}></Route>
								<Route path="/invoiced" element={<Invoices />}></Route>
								<Route path="/reports" element={<Reports />}></Route>
								<Route path="/ros/archived" element={<Archived />}></Route>
							</>
						) : (
							<>
								<Route path="/*" element={<Navigate to={"/portal/no-shops"} />}></Route>
								<Route path="/no-shops/*" element={<NoCustomers />}></Route>
							</>
						)}
					</Routes>
				)}
			</>
		</PortalTemplate>
	);
}
